enum Section {
  EXPERIENCE = 'experience-section',
  CONTACT = 'contact-section'
}

export default Section;
